/**
 * StreamingText Component
 * Displays text with a smooth streaming/typing animation effect
 */
import { useState, useEffect } from 'react';

interface StreamingTextProps {
  content: string;
  speed?: number; // Characters per frame (higher = faster)
  className?: string;
}

export default function StreamingText({ content, speed = 3, className = '' }: StreamingTextProps) {
  const [displayedContent, setDisplayedContent] = useState('');
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    // Reset when content changes
    setDisplayedContent('');
    setIsComplete(false);

    let currentIndex = 0;
    const interval = setInterval(() => {
      if (currentIndex < content.length) {
        // Add multiple characters per frame for faster streaming
        const nextIndex = Math.min(currentIndex + speed, content.length);
        setDisplayedContent(content.slice(0, nextIndex));
        currentIndex = nextIndex;
      } else {
        setIsComplete(true);
        clearInterval(interval);
      }
    }, 16); // ~60fps for smooth animation

    return () => clearInterval(interval);
  }, [content, speed]);

  return (
    <div className={`whitespace-pre-wrap ${className}`}>
      {displayedContent}
      {!isComplete && <span className="animate-pulse">|</span>}
    </div>
  );
}
